/**
 * GitHub Integration API — OAuth initiation (mirrors gitlab.ts).
 */
import fetchWithAuth from "@/api/secureFetch";

const AGENT_BASE_URL = import.meta.env.VITE_API_BASE_URL || "";

export interface InitiateGitHubOAuthRequest {
    userId: number;
}

export interface InitiateGitHubOAuthResponse {
    authUrl?: string;
    authorizationUrl?: string;
    state: string;
}

export async function initiateGitHubOAuth(
    request: InitiateGitHubOAuthRequest,
    token: string
): Promise<InitiateGitHubOAuthResponse> {
    const response = await fetchWithAuth(`${AGENT_BASE_URL}/api/v1/git/github/oauth/authorize`, token, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(request)
    });

    if (!response.ok) {
        throw new Error(`Failed to initiate OAuth: ${response.status}`);
    }

    return response.json();
}
